<template>
	<div>
		<fieldset>
			<div class="label label--margin">
				Algemene gegevens
				<span>Vul hieronder je naam en e-mailadres in en bij welke organisatie je betrokken bent.</span>
			</div>
			<input-text label="Voornaam" name="firstName" v-model="localMeasurement.firstName" />

			<input-text label="Tussenvoegsel" name="infix" v-model="localMeasurement.infix" />

			<input-text label="Achternaam" name="lastName" v-model="localMeasurement.lastName" />

			<input-text label="Emailadres" name="email" v-model="localMeasurement.email" type="email" />

			<select-input
				title="Kies je organisatie"
				label="Organisatie"
				name="organisation"
				:options="[
					'Hoogheemraadschap van Rijnland      ',
					'Hoogheemraadschap van Schieland en Krimpenerwaard ',
					'FLORON',
					'RAVON',
					'De Vlinderstichting',
					'ASN Bank',
					'De Nederlandse Waterschapsbank',
					'Ik ben niet betrokken bij een organisatie',
					'Ik ben betrokken bij een andere organisatie',
				]"
				other-value="Ik ben betrokken bij een andere organisatie"
				other-label="Ik ben betrokken bij..."
				v-model="localMeasurement.organisation"
			/>
		</fieldset>
		<nav>
			<button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">
				Volgende
			</button>
		</nav>
	</div>
</template>

<script>
import InputText from './components/InputText.vue';
import SelectInput from './components/SelectInput.vue';
import FormStep from './FormStep.vue';
export default {
	name: 'FormStep1',
	components: { InputText, SelectInput },
	mixins: [FormStep],
	data() {
		return {
			fieldRequirements: {
				firstName: ['required'],
				lastName: ['required'],
				email: ['required'],
				organisation: ['required'],
			},
		};
	},
};
</script>

<style scoped></style>
